'use client';
import { useEffect, useState } from 'react';
/**
 *
 * @param timeout time till the prop is set
 * @param prop value to set
 * @param onChange callback that can return true when change is handled (and timeout is not necessary)
 * @param onTimeout callback on timeout
 * @returns
 */
export function useDelayedProp<T>(
  timeout: number,
  prop: T,
  onChange?: (newValue: T, oldValue: T) => boolean,
  onTimeout?: () => void,
) {
  const [state, setState] = useState<T>(prop);
  useEffect(() => {
    if (onChange && onChange(prop, state)) {
      setState(prop);
      return;
    }
    const timer = setTimeout(() => {
      setState(prop);
      onTimeout && onTimeout();
    }, timeout);
    return () => clearTimeout(timer);
  }, [prop, timeout]);
  return state;
}
